import React, { MouseEvent } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import LoadingButton from '@mui/lab/LoadingButton';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SceneHeader, { SceneHeaderProps } from '../scene/scene-header';

interface Props extends SceneHeaderProps {
  onSubmit: (e: MouseEvent) => void;
  isSubmitting: boolean;
  isDisabled: boolean;
  children?: React.ReactNode;
  isReadOnly?: boolean;
}

const AppDetailsHeader = ({
  title,
  onSubmit,
  isSubmitting,
  isDisabled,
  border,
  children,
  isReadOnly = false,
}: Props) => {
  const { strings } = useStringsContext();

  return (
    <SceneHeader title={title} border={border}>
      {children}
      <LoadingButton
        onClick={onSubmit}
        type="submit"
        variant="contained"
        color="primary"
        startIcon={<CloudUploadIcon />}
        loading={isSubmitting}
        disabled={isDisabled || isReadOnly}
      >
        {strings.actions.publishChanges}
      </LoadingButton>
    </SceneHeader>
  );
};

export default AppDetailsHeader;
